import { render, staticRenderFns } from "./InvExD.vue?vue&type=template&id=0b0ea564"
import script from "./InvExD.vue?vue&type=script&lang=js"
export * from "./InvExD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports